import {Component, HostListener} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import * as $ from 'jquery';
import {DeviceDetectorService} from 'ngx-device-detector';
import {UserService} from '@services/user.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: []
})
export class AppComponent {
    title = 'LyBox';
    ready = false;

    constructor(
        public authenticationService: AuthenticationService,
        public userService: UserService,
        public deviceService: DeviceDetectorService,
        private dialog: MatDialog,
    ) {
        authenticationService.loadUser().subscribe(() => {
            this.ready = true;
        });

        $(document).ready(() => {
            $(document).on('click', '.collapseBtn', function() {
                $('app-sidebar').toggleClass('collapsed');
                $('#content').toggleClass('extended');
                if (authenticationService.isLogin) {
                    authenticationService.currentUser.user_dashboard.sidebar_collapse = $('app-sidebar').hasClass('collapsed');
                    userService.updateDashboard(authenticationService.currentUser);
                }
            });

            $(document).on('click', 'ul li.isMinimizable .cta_min', function() {
                $(this).parent('li').toggleClass('minimize');
            });

            $(document).on('click', '.card.isMinimizable .card-header', function() {
                $(this).parent('.card').toggleClass('minimize');
                $(this).parent().parent('.card').toggleClass('minimize');
            });

            $(document).on('click', 'td.isMinimizable', function() {
                if ($(this).hasClass('minimize')) {
                    $('.' + $(this).attr('data-target')).show();
                } else {
                    $('.' + $(this).attr('data-target')).hide();
                }
                $(this).toggleClass('minimize');
            });
        });
    }

    // Entrée valide la popup ouverte : déclenche son bouton d'action principal (.btn-primary).
    @HostListener('document:keydown.enter', ['$event'])
    onEnterKey(event: KeyboardEvent) {
        if (event.defaultPrevented || event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) {
            return;
        }
        if (this.dialog.openDialogs.length === 0) {
            return;
        }
        const dialogRef = this.dialog.openDialogs[this.dialog.openDialogs.length - 1];
        const container = document.getElementById(dialogRef.id);
        const target = event.target as HTMLElement;
        if (!container || !target || !container.contains(target)) {
            return;
        }
        // Textes multilignes, boutons et liens gardent leur comportement natif.
        if (['TEXTAREA', 'BUTTON', 'A'].indexOf(target.tagName) !== -1 || target.isContentEditable) {
            return;
        }
        const button = container.querySelector('[mat-dialog-actions] .btn-primary:not([disabled]), ' +
            'mat-dialog-actions .btn-primary:not([disabled])') as HTMLElement;
        if (!button) {
            return;
        }
        // Évite en plus la soumission implicite du <form>, qui doublerait l'action.
        event.preventDefault();
        button.click();
    }
}
